var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "r-template u-col" },
    [
      _c("item-header", { staticClass: "header" }),
      _vm._v(" "),
      _vm.canvas
        ? _c(
            "div",
            { staticClass: "u-flex u-row" },
            [
              _c("item-toolbar", { staticClass: "toolbar bar" }),
              _vm._v(" "),
              _c("item-canvas", { staticClass: "canvas u-flex" }),
              _vm._v(" "),
              _c("item-aside", { staticClass: "aside bar" })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }